import React from 'react';
import {connect} from 'react-redux';
import StepHeader from '../StepHeader';
import { ticketQuantityIncrease, ticketQuantityDecrease, promoCodePanelShow } from '../../../actions/creators/checkout/tickets';
import LinkButton from "../../LinkButton";
import PromoCodePanel from "../PromoCodePanel";
import TicketsBlock from './TicketsBlock';
import { prevStep } from '../../../actions/creators/checkout';
import { getCheckoutOrderTicketsSeatsCount, getCheckoutSelectedSeats, getTicketsCheckoutFirstStepConfig } from '../../../reducers';

class TicketsSelection extends React.Component {
  render() {
    if (this.props.promoCodesPanel.visible) {
      return <PromoCodePanel processing={this.props.promoCodesPanel.processing}/>;
    }
    
    const limit = 'seats' === this.props.firstStep
      ? Math.min(this.props.session.tickets_limit, this.props.seats.length)
      : this.props.session.tickets_limit;
    const remaining = limit - this.props.ticketsSeatsCount;
    const limitReached = remaining <= 0;
    const benefits = this.props.tickets.filter(ticket => ticket.extra.recognition);
    const regular = this.props.tickets.filter(ticket => !ticket.extra.recognition);

    return (
        <React.Fragment>
          <StepHeader onPrevClick={this.props.prevStep} label="Selecciona tus boletos" />
          
          <TicketsBlock
            tickets={benefits}
            title="Tus beneficios"
            onIncrease={this.props.ticketIncrease}
            onDecrease={this.props.ticketDecrease}
            limitReached={limitReached}
            remaining={remaining}
          />
          
          <TicketsBlock
            tickets={regular}
            title={benefits.length > 0 ? 'Boletos generales' : ''}
            onIncrease={this.props.ticketIncrease}
            onDecrease={this.props.ticketDecrease}
            limitReached={limitReached}
            remaining={remaining}
          />

          <p className="mt-5 lead text-center">
            <LinkButton onClick={this.props.promoCode ? null : this.props.showPromoCodePanel} disabled={!!this.props.promoCode}>
              ¿Tienes un código promocional?
            </LinkButton>
          </p>

          {this.props.promoCode
            ? <p className='checkout-disclaimer text-center mb-5'>Solo es posible usar un código promocional/tarjeta Cinefan por transacción.<br/>Si deseas usar uno diferente al que ingresaste, puedes refrescar la página o <a href="javascript:location.reload()">hacer click aquí</a>.</p>
            : ''}
        </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  firstStep: getTicketsCheckoutFirstStepConfig(state),
  promoCodesPanel: state.checkoutData.ui.promoCodesPanel,
  promoCode: state.checkoutData.promoCode.code,
  seats: getCheckoutSelectedSeats(state),
  ticketsSeatsCount: getCheckoutOrderTicketsSeatsCount(state),
});

const mapDispatchToProps = dispatch => ({
  ticketIncrease: ticket => dispatch(ticketQuantityIncrease(ticket)),
  ticketDecrease: ticket => dispatch(ticketQuantityDecrease(ticket)),
  showPromoCodePanel: () => dispatch(promoCodePanelShow(true)),
  prevStep: () => dispatch(prevStep()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketsSelection);